"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const assert_1 = require("./assert");
exports.opNameForOperationTypeNode = (operation) => {
    switch (operation) {
        case "mutation":
            return "Mutation";
        case "query":
            return "Query";
        case "subscription":
            return "Subscription";
        default:
            assert_1.unreachable();
    }
};
exports.getOperationName = (document) => {
    assert_1.assert(document.kind === "Document", "kind must be Document");
    const definition = document.definitions.find(d => d.kind === "OperationDefinition");
    assert_1.assert(definition && definition.name, "no OperationDefinition found");
    return [
        exports.opNameForOperationTypeNode(definition.operation),
        definition.name.value,
    ];
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ3JhcGhxbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsL2dyYXBocWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFDQSxxQ0FBNEM7QUFFL0IsUUFBQSwwQkFBMEIsR0FBRyxDQUFDLFNBQTRCLEVBQUUsRUFBRTtJQUN2RSxRQUFRLFNBQVMsRUFBRTtRQUNmLEtBQUssVUFBVTtZQUNYLE9BQU8sVUFBVSxDQUFBO1FBQ3JCLEtBQUssT0FBTztZQUNSLE9BQU8sT0FBTyxDQUFBO1FBQ2xCLEtBQUssY0FBYztZQUNmLE9BQU8sY0FBYyxDQUFBO1FBQ3pCO1lBQ0ksb0JBQVcsRUFBRSxDQUFBO0tBQ3BCO0FBQ0wsQ0FBQyxDQUFBO0FBRVksUUFBQSxnQkFBZ0IsR0FBRyxDQUFDLFFBQXNCLEVBQUUsRUFBRTtJQUN2RCxlQUFNLENBQUMsUUFBUSxDQUFDLElBQUksS0FBSyxVQUFVLEVBQUUsdUJBQXVCLENBQUMsQ0FBQTtJQUU3RCxNQUFNLFVBQVUsR0FBRyxRQUFRLENBQUMsV0FBVyxDQUFDLElBQUksQ0FDeEMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsSUFBSSxLQUFLLHFCQUFxQixDQUNELENBQUE7SUFFeEMsZUFBTSxDQUFDLFVBQVUsSUFBSSxVQUFVLENBQUMsSUFBSSxFQUFFLDhCQUE4QixDQUFDLENBQUE7SUFFckUsT0FBTztRQUNILGtDQUEwQixDQUFDLFVBQVUsQ0FBQyxTQUFTLENBQUM7UUFDaEQsVUFBVSxDQUFDLElBQUksQ0FBQyxLQUFLO0tBQ2YsQ0FBQTtBQUNkLENBQUMsQ0FBQSJ9